"use client";

import React from "react";
import { FaTimes } from "react-icons/fa";
import { motion } from "motion/react";
import { cn } from "@/lib/utils";
import { useParams } from "next/navigation";

interface DialogProps {
  onClose: () => void;
  children: React.ReactNode;
}

// Animation with fade in and fade out

export const Dialog = ({ onClose, children }: DialogProps) => {
  const { locale } = useParams();
  return (
    <div className="fixed inset-0 bg-transparent bg-opacity-50 z-[20000] text-white backdrop-blur-sm flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="relative bg-white rounded-lg p-4 w-full md:max-w-xl min-h-[200px] shadow-lg border"
      >
        <button
          className={cn(
            "absolute top-3  text-black",
            locale === "en" ? "right-3" : "left-3"
          )}
          onClick={onClose}
        >
          <FaTimes />
        </button>
        {children}
      </motion.div>
    </div>
  );
};
